import { InvestorType } from "./documents.interface";

export enum KycStatus {
  VERIFIED = "verified",
  PROCESSING = "processing",
  PENDING = "pending",
  MANUAL_REVIEW = "manual-review",
  UPDATES_REQUIRED = "updates-required",
  REJECTED = "service-denied",
  EXPIRED = "expired",
  NOT_VERIFIED = "not-verified",
}

export interface ContactDetails {
  phone: {
    code: string;
    number: string;
    fullNumber: string;
    isVerified: boolean;
  };
}

export interface Address {
  countryCode: string;
  state: string;
  houseNumber: string;
  street: string;
  city: string;
  zip: string;
  entrance?: string;
}

export interface TaxInfo {
  taxId: string;
  taxCountryCode: string;
  _id: string;
}

export interface InvestorDetails {
  address: Address;
  tax: TaxInfo[];
  comment: string;
  investorType: string;
  verificationComment: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  displayName: string;
  comments: any[];
  verificationComments: any[];
  gender?: string;
  birthCountry?: string;
  phone?: {
    isVerified: boolean;
    fullNumber: string;
    code: string;
    number: string;
  };
  entityName?: string;
  businesses?: string;
  entityIdNumber?: string;
  entityType?: string;
  incorporationDate?: string;
  leiCode?: string;
  lineOfBusiness?: string;
  sourceOfFunds?: string;
  website?: string;
}

export interface UserInvestor {
  investorId: string;
  createDate: string;
  verificationErrors: any[];
  allVerificationErrors: any[];
  isHidden: boolean;
  details: InvestorDetails;
  email: string;
  contactEmail: string;
  mixPanelId: string;
  analyticsEnabled: boolean;
  verificationLevel: string;
  verificationStatus: string;
  verificationSubStatus: string;
  accreditationStatus: string;
  accreditationStatusComment: string | null;
  accreditationStatusComments: any[];
  accreditationStatusChangeDate: string | null;
  accreditationId: string | null;
  pendingDeletion: boolean;
  deletionDeclineDate: string | null;
  lastIssuerContext: {
    issuerId: string | null;
    date: string;
  };
  brokerDealerId: number;
  requestedUpdates: any[];
  labels: any[];
  accountStatus: string;
  accountStatusSignature: string;
  accountEuStatus: string;
  accountEuStatusSignature: string;
  assignedAttorneyOperatorId: string;
  annualIncome: any[];
  approvedIssuerIds: string[];
  lastLoggedIn: string;
  role: string;
}

export interface UserInfo {
  investorId: string;
  isHidden: boolean;
  mixPanelId: string;
  analyticsEnabled: boolean;
  email: string;
  contactEmail: string;
  verificationErrors: any[];
  fullName: string;
  entityName: string;
  entityType: string;
  verificationStatus: KycStatus;
  accountStatus: string;
  tfaEnabled: boolean;
  investorType: InvestorType;
  state: string;
  countryCode: string;
  pendingDeletion: boolean;
  deletionDeclineDate: string | null;
  brokerDealerId: number;
  accreditationStatus: string;
  requestedUpdates: any[];
  language: string;
  contactDetails: ContactDetails;
  investorUserId: string;
  investorUserEmail: string;
  userInvestors: UserInvestor[];
  role: string;
  isEnhancedVerificationRequested: boolean;
  intent: string;
}
